import { useParams, Link, Navigate } from 'react-router-dom';
import { ArrowLeft, Clock } from 'lucide-react';
import { getArticleBySlug, ARTICLES } from '../data/articles';
import AdBanner from '../components/AdBanner';

export default function BlogArticle() {
  const { slug } = useParams<{ slug: string }>();
  const article = slug ? getArticleBySlug(slug) : undefined;

  if (!article) return <Navigate to="/blog" replace />;

  const blocks = article.content.trim().split('\n\n');
  const related = ARTICLES.filter(a => a.slug !== article.slug && a.category === article.category).slice(0, 2);

  return (
    <div className="max-w-3xl mx-auto">
      <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-blue-600 mb-6">
        <ArrowLeft className="w-4 h-4" /> Back to all articles
      </Link>

      <section className="mb-8">
        <span className="inline-block bg-blue-50 text-blue-600 text-xs font-medium px-2.5 py-1 rounded-full mb-4">
          {article.category}
        </span>
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-4">{article.title}</h1>
        <p className="text-gray-500 flex items-center gap-1.5 text-sm">
          <Clock className="w-4 h-4" /> {article.readTime}
        </p>
      </section>

      <AdBanner slot="2222222222" format="horizontal" className="min-h-[90px] bg-gray-100 rounded-lg mb-8" />

      <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-8 md:p-12 prose prose-sm max-w-none space-y-5 mb-10">
        {blocks.map((block, i) => {
          if (block.startsWith('## ')) {
            return <h2 key={i} className="text-xl font-bold text-gray-900 mt-2">{block.slice(3)}</h2>;
          }
          return <p key={i} className="text-gray-600 leading-relaxed">{block}</p>;
        })}
      </div>

      {related.length > 0 && (
        <section className="mb-16">
          <h2 className="text-xl font-bold text-gray-900 mb-4">Related articles</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {related.map(r => (
              <Link
                key={r.slug}
                to={`/blog/${r.slug}`}
                className="bg-white rounded-xl border border-gray-100 shadow-sm p-5 hover:shadow-md transition-shadow"
              >
                <h3 className="font-semibold text-gray-900 mb-1.5">{r.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{r.excerpt}</p>
              </Link>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
